<template>
  <HalloweenGenericButton :disabled="isProcessing" @click="handleTokenAdd(token)">
    {{ $t('walletAddToWallet') }}
    <template #icon>
      <img src="/img/icons/mm-icon.png" alt="metamask" class="tw:mr-2" />
    </template>
  </HalloweenGenericButton>
</template>

<script lang="ts" setup>
import { useWeb3ModalProvider } from '@web3modal/ethers/vue';
import type { ITokenModel } from '~/types/apiService';

defineProps<{
  token: ITokenModel;
}>();

const { addTokenToWallet } = useWalletMethods();
const { walletProvider } = useWeb3ModalProvider();

const isProcessing = ref(false);

const handleTokenAdd = async (token: ITokenModel): Promise<void> => {
  if (!walletProvider) {
    return;
  }

  const options = {
    address: token.tokenContractAddress,
    decimals: 18,
    image: `https://pearldivergame.com${(getIcon(0, token.tokenContractAddress) || '').replace('/_nuxt/public', '')}`
  };

  try {
    isProcessing.value = true;
    await addTokenToWallet(options);
  } finally {
    isProcessing.value = false;
  }
};
</script>
